(function(){
  var Z=window.ZF||{};
  var $=function(s,r){return (r||document).querySelector(s);},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  var calm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canDialog=typeof HTMLDialogElement==='function';

  function money(cents){
    var f=Z.moneyFormat||'Rs. {{amount_no_decimals}}';
    function group(n,d,th,dec){n=(n/100).toFixed(d);var p=n.split('.');p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,th);return p.join(dec);}
    return f.replace(/\{\{\s*(\w+)\s*\}\}/,function(_,k){
      if(k==='amount')return group(cents,2,',','.');
      if(k==='amount_no_decimals')return group(cents,0,',','.');
      if(k==='amount_with_comma_separator')return group(cents,2,'.',',');
      if(k==='amount_no_decimals_with_comma_separator')return group(cents,0,'.',',');
      return group(cents,2,',','.');
    });
  }

  /* Dialog panels */
  function closeOnBackdrop(d){d.addEventListener('click',function(e){if(e.target===d)d.close();});}
  $$('dialog').forEach(closeOnBackdrop);
  $$('[data-close]').forEach(function(b){b.addEventListener('click',function(){b.closest('dialog').close();});});
  var menu=$('#zf-menu');
  $$('[data-open-menu]').forEach(function(b){b.addEventListener('click',function(){if(menu&&canDialog)menu.showModal();});});
  if(menu)$$('a',menu).forEach(function(a){a.addEventListener('click',function(){menu.close();});});

  /* Cart */
  var drawer=$('#zf-cart'),list=$('#zf-cart-list'),total=$('#zf-cart-total'),errBox=$('#zf-cart-err');
  function setCount(n){$$('[data-cart-count]').forEach(function(c){c.textContent=n;c.hidden=!n;});}
  function renderCart(cart){
    setCount(cart.item_count);
    if(!list)return;
    list.textContent='';
    var foot=$('#zf-cart-foot');
    if(foot)foot.hidden=!cart.item_count;
    if(!cart.items.length){var e=document.createElement('p');e.textContent='Your cart is empty.';e.style.padding='18px 0';list.appendChild(e);return;}
    cart.items.forEach(function(it,i){
      var row=document.createElement('div');row.className='line';
      var im=document.createElement('img');im.src=it.image?(it.image+(it.image.indexOf('?')>-1?'&':'?')+'width=160'):Z.pouch;im.alt=it.product_title;im.width=72;im.height=88;row.appendChild(im);
      var b=document.createElement('div');
      var n=document.createElement('div');n.className='line__name';n.textContent=it.product_title;b.appendChild(n);
      if(it.variant_title){var v=document.createElement('div');v.className='line__var';v.textContent=it.variant_title;b.appendChild(v);}
      var r=document.createElement('div');r.className='line__row';
      var st=document.createElement('div');st.className='stepper stepper--sm';
      [['-',it.quantity-1,'Decrease quantity'],['q'],['+',it.quantity+1,'Increase quantity']].forEach(function(o){
        if(o[0]==='q'){var s=document.createElement('input');s.type='text';s.readOnly=true;s.value=it.quantity;s.setAttribute('aria-label','Quantity');st.appendChild(s);return;}
        var x=document.createElement('button');x.type='button';x.textContent=o[0];x.setAttribute('aria-label',o[2]);x.addEventListener('click',function(){change(i+1,o[1]);});st.appendChild(x);
      });
      r.appendChild(st);
      var p=document.createElement('b');p.textContent=money(it.final_line_price);r.appendChild(p);b.appendChild(r);
      var rm=document.createElement('button');rm.type='button';rm.className='line__rm';rm.textContent='Remove';rm.addEventListener('click',function(){change(i+1,0);});b.appendChild(rm);
      row.appendChild(b);list.appendChild(row);
    });
    if(total)total.textContent=money(cart.total_price);
  }
  function fail(box,msg){if(box)box.textContent=msg||'Something went wrong. Please try again or order on WhatsApp.';}
  function api(url,opts){return fetch(url,opts).then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message);return j;});});}
  function change(line,qty){
    if(errBox)errBox.textContent='';
    api((Z.routes.change||'/cart/change')+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:line,quantity:qty})}).then(renderCart).catch(function(e){fail(errBox,e.message);});
  }
  function openCart(){return api(Z.routes.cart+'.js',{headers:{Accept:'application/json'}}).then(function(c){renderCart(c);if(drawer&&canDialog&&!drawer.open)drawer.showModal();});}
  $$('[data-open-cart]').forEach(function(a){a.addEventListener('click',function(e){if(!drawer||!canDialog)return;e.preventDefault();openCart().catch(function(){location.href=a.href;});});});

  /* Product form: package choice, quantity, gallery */
  $$('[data-buy]').forEach(function(form){
    var err=$('[data-err]',form),price=$('[data-price-show]',form),idInput=$('input[name=id][type=hidden]',form),btns=$$('button[type=submit]',form);
    var stickP=$('[data-stick-price]'),stickN=$('[data-stick-name]');
    function sync(r){
      if(!r)return;
      if(idInput)idInput.value=r.value;
      if(price)price.textContent=r.dataset.price;
      if(stickP)stickP.textContent=r.dataset.price;
      if(stickN)stickN.textContent=r.dataset.name;
    }
    $$('input[data-plan]',form).forEach(function(r){r.addEventListener('change',function(){sync(r);});if(r.checked)sync(r);});
    var q=$('input[name=quantity]',form);
    $$('[data-q]',form).forEach(function(b){b.addEventListener('click',function(){q.value=Math.max(1,(parseInt(q.value,10)||1)+parseInt(b.dataset.q,10));});});
    form.addEventListener('submit',function(e){
      var s=e.submitter;
      if(s&&s.name==='return_to')return; /* Buy Now: Shopify takes the package straight to checkout */
      if(!drawer||!canDialog)return;
      e.preventDefault();if(err)err.textContent='';
      var fd=new FormData(form);fd.delete('return_to');
      btns.forEach(function(b){b.disabled=true;});
      api(Z.routes.add+'.js',{method:'POST',headers:{Accept:'application/json'},body:fd}).then(openCart).catch(function(x){fail(err,x.message);}).then(function(){btns.forEach(function(b){b.disabled=false;});});
    });
  });
  $$('[data-gal]').forEach(function(g){
    var main=$('[data-gal-main]',g),img=main&&$('img',main);
    $$('[data-thumb]',g).forEach(function(t){t.addEventListener('click',function(){
      $$('[data-thumb]',g).forEach(function(x){x.setAttribute('aria-current','false');});t.setAttribute('aria-current','true');
      img.src=t.dataset.src;img.removeAttribute('srcset');img.alt=t.dataset.alt||'';if(t.dataset.w){img.width=t.dataset.w;img.height=t.dataset.h;}main.dataset.zoom=t.dataset.full;
    });});
  });

  /* Zoom */
  var zoom=$('#zf-zoom');
  if(zoom&&canDialog){
    var zs=$('.zoom__stage',zoom),zi=$('img',zoom);
    document.addEventListener('click',function(e){var t=e.target.closest&&e.target.closest('[data-zoom]');if(!t)return;var im=$('img',t);zi.src=t.dataset.zoom;zi.alt=im?im.alt:'';zs.classList.remove('big');zoom.showModal();});
    zi.addEventListener('click',function(){zs.classList.toggle('big');});
  }

  /* Sticky bar */
  var stick=$('[data-stick]'),anchor=stick&&$('[data-buy]');
  function onScroll(){
    if(stick&&anchor){var on=anchor.getBoundingClientRect().bottom<0;stick.classList.toggle('on',on);document.body.classList.toggle('stick-on',on);}
    var t=$('[data-top]');if(t)t.classList.toggle('on',window.scrollY>700);
  }
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();
  var topBtn=$('[data-top]');if(topBtn)topBtn.addEventListener('click',function(){window.scrollTo({top:0,behavior:calm?'auto':'smooth'});});

  /* Reveal only what JS can bring back */
  if('IntersectionObserver' in window&&!calm){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -6% 0px'});
    $$('[data-reveal]').forEach(function(el){if(el.getBoundingClientRect().top>innerHeight){el.classList.add('reveal');io.observe(el);}});
  }

  /* Hero depth: follows the pointer on desktop, rests on phones */
  var hero=$('[data-hero]');
  if(hero){
    var rig=$('.hero__rig',hero);
    if('IntersectionObserver' in window)new IntersectionObserver(function(es){hero.classList.toggle('is-off',!es[0].isIntersecting);}).observe(hero);
    if(rig&&!calm&&matchMedia('(hover: hover)').matches){
      var pending=false,x=0,y=0;
      hero.addEventListener('pointermove',function(e){var r=rig.getBoundingClientRect();x=(e.clientX-r.left)/r.width;y=(e.clientY-r.top)/r.height;if(pending)return;pending=true;requestAnimationFrame(function(){pending=false;
        var cx=Math.max(-1,Math.min(1,x*2-1)),cy=Math.max(-1,Math.min(1,y*2-1));
        rig.style.setProperty('--ry',(cx*9).toFixed(2)+'deg');rig.style.setProperty('--rx',(-cy*6).toFixed(2)+'deg');rig.style.setProperty('--mx',(x*100).toFixed(1)+'%');rig.style.setProperty('--my',(y*100).toFixed(1)+'%');
      });},{passive:true});
      hero.addEventListener('pointerleave',function(){rig.style.setProperty('--ry','0deg');rig.style.setProperty('--rx','0deg');});
    }
  }
  if(window.Shopify&&Shopify.designMode)$$('.reveal').forEach(function(e){e.classList.add('in');});
})();
